import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-profile-type-dialog',
  templateUrl: './profile-type-dialog.component.html',
  styleUrls: ['./profile-type-dialog.component.scss']
})
export class ProfileTypeDialogComponent implements OnInit {

  selectedImageValues: any;
  selectedImageType: any;
  duplicateModalData: any;
  grid2Type: any;
  duplicateModalMatchedHeaders: any[] = [];
  duplicateModalHeaders: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<ProfileTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) { 
    if (this.data && this.data.selectedValues) {
      this.selectedImageValues = this.data.selectedValues;
      console.log(this.selectedImageValues, 'dsa');
      this.selectedImageType = this.data.imgType;
    }

    if (this.data && this.data.modalData) {
      this.data.imgType == 'M' ? this.prepareDuplicateMMSeriousHeaders() : this.prepareDuplicateModalHeaders();
      this.duplicateModalData = this.data.modalData;
      this.grid2Type = this.data.gridType;
      this.selectedImageType = this.data.imgType;
    }
  }

  prepareDuplicateModalHeaders() {
    this.duplicateModalMatchedHeaders = [
      { title: 'InactiveFromDate', value: 'inactivateFromdate' },
      { title: 'InactiveToDate', value: 'inactivetodate' },
      { title: 'Reason', value: 'reason4InActive' },
      { title: 'InactivateRequestBy', value: 'inactivaterequestby' },
      { title: 'Inactive By Emp', value: 'profileOwnerEmpName' },
    ];
    this.duplicateModalHeaders = [
      'inactivateFromdate',
      'inactivetodate',
      'reason4InActive',
      'inactivaterequestby',
      'profileOwnerEmpName',
    ];
  }

  prepareDuplicateMMSeriousHeaders() {
    this.duplicateModalMatchedHeaders = [
      { title: 'ProfileID', value: 'profileID' },
      { title: 'Name', value: 'firstName' },
      { title: 'LastName', value: 'lastName' },
      { title: 'ProfileOwner', value: 'empName' },
      { title: 'MeetingDate', value: 'meetingDate' },
    ];
    this.duplicateModalHeaders = [
      'profileID',
      'firstName',
      'lastName',
      'empName',
      'meetingDate',
    ];
  }

  ngOnInit(): void {
  }

  onNoClick() {
    this.dialogRef.close();
  }

}
